import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { Service } from './base-service'

export const messagesService = new Service('/comments/message', HALApiService, createItemsData)
